import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify"; // 👈 اضافه شد

const ClosePositionForm = () => {
  const [formData, setFormData] = useState({
    target: "individuals",
    reason: "",
    confirmed: true,
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/positions/close`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data.success || response.data.ok) {
        const successMessage = "موقعیت‌ها با موفقیت بسته شدند";
        setMessage(successMessage);
        toast.success(successMessage); // 👈 اضافه شد
        
        setFormData({
          target: "individuals",
          reason: "",
          confirmed: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage = error.response?.data?.message || "خطا در بستن موقعیت‌ها";
      setMessage(errorMessage);
      toast.error(errorMessage); // 👈 اضافه شد
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 p-6">
      <div className="bg-red-900/20 border border-red-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>🔒</span> بستن پوزیشن‌ها
        </h3>
        <p className="text-red-300 text-sm">
          ⚠️ توجه: این عملیات تمام موقعیت‌های باز را برای دسته انتخاب شده
          می‌بندد
        </p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب:
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={formData.target === "individuals"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={formData.target === "groups"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
          <p className="text-gray-400 text-xs mt-3">
            با انتخاب هر گزینه، تمام موقعیت‌های باز آن دسته بسته خواهند شد
          </p>
        </div>

        {/* دلیل بستن */}
        <div>
          <label className="block text-white font-medium mb-2">
            دلیل بستن موقعیت <span className="text-red-400">*</span>
          </label>
          <textarea
            value={formData.reason}
            onChange={(e) =>
              setFormData({ ...formData, reason: e.target.value })
            }
            placeholder="لطفاً دلیل بستن موقعیت‌ها را به طور کامل توضیح دهید..."
            className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-red-500 focus:outline-none resize-none"
            rows="4"
            required
          />
          <p className="text-gray-400 text-xs mt-2">
            این دلیل در سیستم ثبت خواهد شد
          </p>
        </div>

        {/* Confirmation Info */}
        <div className="bg-yellow-900/20 border border-yellow-600 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">⚠️</span>
            <div>
              <h4 className="text-yellow-400 font-medium mb-2">
                تأیید نهایی عملیات
              </h4>
              <ul className="text-gray-300 text-sm space-y-1">
                <li>
                  • تمام موقعیت‌های باز برای{" "}
                  {formData.target === "individuals"
                    ? "حساب‌های فردی"
                    : "گروه‌ها"}{" "}
                  بسته خواهند شد
                </li>
                <li>• این عملیات غیرقابل بازگشت است</li>
                <li>• دلیل شما در سیستم ثبت می‌شود</li>
              </ul>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading || !formData.reason.trim()}
          className="w-full py-4 px-6 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
              در حال بستن موقعیت‌ها...
            </>
          ) : (
            <>
              <span>🔒</span>
              بستن تمام موقعیت‌ها
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default ClosePositionForm;